<template>
  <div style="display: flex; justify-content: center; margin: 0">
    <el-row>
      <el-col :span="24">
        <div class="login-logo">
          <img src="@/assets/img/erp-login-m.png" style="width: 230px" />
        </div>
      </el-col>
      <el-col :span="24">
        <el-form :model="loginform" label-width="0px">
          <el-form-item>
            <el-input
              v-model="loginform.loginname"
              :prefix-icon="Avatar"
              placeholder="用户名"
              input-style="border-radius:25px"
              size="large"
              @keyup.enter="Login"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="loginform.loginpassword"
              type="password"
              :prefix-icon="Lock"
              placeholder="密码"
              :show-password="true"
              @keyup.enter="Login"
              size="large"
              input-style="border-radius:25px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              round
              class="login-operation"
              size="large"
              @click="Login"
              @keyup.enter="Login"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { reactive, onBeforeMount } from 'vue';
import { ElMessage } from 'element-plus';
import { Avatar, Lock } from '@element-plus/icons-vue';
import store from '@/store/index';
import router from '@/router/index';
import auth from '@/network/auth';
// import { useUserProfileStore } from '@/store/useProfile';
import { PBKDF2 } from '@/assets/js/cryptoHepler';
import { useAuthorityStore } from '@/store/authority';
import { routeParamsStore } from '@/store/routeParams';
import URLParams from '@/assets/js/URLParams';
const loginform = reactive({
  loginname: '',
  loginpassword: '',
});

// const useUserProfile = useUserProfileStore();

onBeforeMount(() => {
  store.commit('setIsAuth', false);
  store.commit('setToken', '');
  localStorage.clear();
});

const Login = async () => {
  console.log(
    '密码加密test1:',
    loginform.loginpassword,
    PBKDF2(loginform.loginpassword)
  );
  var password = PBKDF2(loginform.loginpassword);
  const loginpost = await auth
    .login(loginform.loginname, password, process.env.VUE_APP_VERSION)
    .then((res) => res);
  //if (loginpost.statusText === 'OK') {
  if (loginpost.status === 200) {
    if (loginpost.data.success != true) {
      ElMessage({
        message: loginpost.data.message,
        type: 'error',
      });
      return;
    }
    //token
    const token = loginpost.data.data.token;
    // console.log("token", token);
    localStorage.removeItem('xToken');
    localStorage.setItem('xToken', token);
    store.commit('setToken', token);
    store.commit('setIsAuth', true);

    localStorage.setItem('enable_new_login', loginpost.data.enableNewLogin);
    // 更新用户角色
    // await setUserSalesAdmin();
    //设置权限
    await useAuthorityStore().SetAuthData();

    const backUrl = URLParams.get('backurl');
    if ((backUrl || '') !== '') {
      var UrlObject = new URL(backUrl);
      var first = URLParams.first(UrlObject.searchParams);

      window.location.href = backUrl;
      return;
    }

    const useAuthority = useAuthorityStore();
    const useParam = routeParamsStore();
    //有my task list 权限登录至mytasklist
    if (useAuthority.GetAuthority('Menu_MyTaskList_read')) {
      useParam.home = 'myTask';
      router.push('/MyTask');
      return;
    }
    useParam.home = '';
    router.push('/report');
  } else {
    ElMessage({
      message: loginpost.msg,
      type: 'error',
    });
  }
};

// const setUserSalesAdmin = async () => {
//   useUserProfile.getUser();
// };
</script>

<style scoped>
.login-logo {
  padding-bottom: 20pt;
}

.login-operation {
  width: 100%;
}
</style>
